var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 86,
    viewBox: "0 0 88 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 84.6001H75.9",
    stroke: "#989898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60.8999V74.4999C49 79.9999 53.5 84.4999 59 84.4999H65.8",
    stroke: "#989898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60.8999V74.4999C39 79.9999 34.5 84.4999 29 84.4999H22.2",
    stroke: "#989898",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 62.3C1 65.6 3.7 68.3001 7 68.3001H81C84.3 68.3001 87 65.6 87 62.3V59.3H1V62.3Z",
    fill: "#989898"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87 19.3C87 16 84.3 13.3 81 13.3H7C3.7 13.3 1 16 1 19.3V56.3H87V19.3Z",
    fill: "#989898"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9 0H26.2C23.5 0 21.5 2.2 21.5 4.8V11.2V56.3H65.4V8.5C65.4 8.3 65.4 8.2 65.4 7.9V5.9V5C65.3 3.3 66 1.6 66.9 0Z",
    fill: "#82AA00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 6.59995H77.9V4.99995C77.9 2.39995 76 0.199951 73.3 0.199951C70.6 0.199951 68.6 2.39995 68.6 4.99995V5.99995V6.59995H68.5Z",
    fill: "#82AA00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29 13.9H57.3V8.69995H29V13.9Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 24.3001H57.5V21.1001H28.8V24.3001Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1 30.5999H57.4V27.3999H41.1V30.5999Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 30.5999H37.2V27.3999H28.8V30.5999Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 47.4998L39.1 40.5998L46.7 47.0998L56.9 38.7998",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 43.1999V37.8999H52.1C52.1 37.9999 57.5 43.3999 57.5 43.1999Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.12d05b8def9e60130be493392ea588ee.svg";
export { ForwardRef as ReactComponent };